import React, { useEffect } from "react";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import AdminDashboard from "./AdminDashboard";
import "./Admin.css";

export default function AdminLogin() {
  // Clear stale Amplify auth tokens that cause
  // "Local storage is missing an ID Token" on first login attempt
  useEffect(() => {
    try {
      const keys = Object.keys(localStorage);
      const hasIdToken = keys.some(
        (k) => k.includes("idToken") || k.includes("IdToken")
      );
      const hasAccessToken = keys.some(
        (k) => k.includes("accessToken") || k.includes("AccessToken")
      );
      if (hasIdToken !== hasAccessToken) {
        keys.forEach((k) => {
          if (k.startsWith("CognitoIdentityServiceProvider")) {
            localStorage.removeItem(k);
          }
        });
      }
    } catch (e) { /* ignore */ }
  }, []);

  return (
    <div className="admin-login-wrapper">
      <Authenticator hideSignUp>
        {({ signOut, user }) => (
          <AdminDashboard user={user} signOut={signOut} />
        )}
      </Authenticator>
    </div>
  );
}
